//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        votes: Object,
        name: String
    },
    computed: {
        like_percent () {
            return this.votes.positive.like_count / this.join_count
        },
        like_percent_tx () {
            return Math.round(this.like_percent * 100) + '%'
        },
        dislike_percent () {
            return 1 - this.like_percent
        },
        dislike_percent_tx () {
            return Math.round(this.dislike_percent * 100) + '%'
        },
        join_count () {
            return ['negative', 'positive'].reduce((count, key) => {
                return count + this.votes[key].like_count
            }, 0)
        },
        picked () {
            return ['negative', 'positive'].some((key) => {
                return this.votes[key].is_liked
            })
        },
        is_liked_negative(){
            return this.votes['negative'].is_liked
        },
        is_liked_positive(){
            return this.votes['positive'].is_liked
        }
    },
    methods: {
    }
}
